<template>
  <tr class="Conter_list" v-if="horizontalType==1">
    <v-switch-item1
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in list"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
      />
  </tr>
  <td class="lan t_Edit_caption_3 ftd" style="width:20%;height:75px;" v-else-if="horizontalType==2">
    <v-switch-item2
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in list"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
      />
  </td>
  <tr class="Conter_list" v-else-if="horizontalType==3">
    <v-switch-item3
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in list"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
      />
  </tr>
  <tr class="Conter_list" v-else-if="horizontalType==4">
    <v-switch-item4
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in list"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
      />
  </tr>
  <span v-else-if="horizontalType==5">
    <v-switch-item5
        :selectRule="selectRule"
        :chip="chip"
        class="switch-1"
        v-for="(item, index) in list"
        :key="'item' + index"
        :item="item"
        :type="type"
        :class="'w-' + columns"
        :isSelectAll="isSelectAll"
      />
  </span>
</template>

<script>
import VSwitchItem1 from "../switch-item/g_switch-item6";
import VSwitchItem2 from "../switch-item/g_switch-item7";
import VSwitchItem3 from "../switch-item/g_switch-item8";
import VSwitchItem4 from "../switch-item/g_switch-item9";
import VSwitchItem5 from "../switch-item/g_switch-item11";
import Vue from "../../../utils/bus";
export default {
  name: "g_switch-6",
  components: {
    VSwitchItem1,
    VSwitchItem2,
    VSwitchItem3,
    VSwitchItem4,
    VSwitchItem5
  },
  props: {
    selectRule: {
      type: Function,
      default: () => true
    },
    chip: String,
    horizontalType: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 5
    },
    title: {
      type: String,
      default: "title"
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      isSelectAll: false,
      key:0
    };
  },
  created() {
    Vue.$on("changSelect", (item) => {
       if(item == this.title||item=="all"){
         if(this.isSelectAll){
           this.isSelectAll=false;
         }else {
           this.isSelectAll=true;
         }
      }
    });
    Vue.$on("reset",()=>{
      this.isSelectAll=false;
    });
     Vue.$on("resetDefault",()=>{
      this.isSelectAll=false;
    })
  },
  computed: {
    type() {
      let _type = 1;
      switch (this.horizontalType) {
        case 1:
          _type = 1;
          break;
        case 2:
          _type = 3;
          break;
        case 3:
          _type = 5;
          break;
      }
      return _type;
    }
  }
};
</script>

<style scoped lang="stylus">
$border-color = #E6E6E6;

.g_switch-1 {
  h3 {
    width: 100%;
    height: 26px;
    border: 1px solid $border-color;
    position: relative;
    font-size: 13px;
    box-sizing: border-box;
    text-align: center;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 2px;
    background: linear-gradient(#FEFEFE, #F0F0F0);

    span {
      display: inline-block;
      position: relative;

      &:before, &:after {
        top: 50%;
        display: block;
        content: '';
        height: 1px;
        position: absolute;
      }

      &:before {
        left: -45px;
      }

      &:after {
        right: -45px;
      }
    }
  }

  .g_switch-wrap {
    font-size: 13px;
    position: relative;
    overflow: hidden;
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;

    &:after {
      left: 0;
      width: 100%;
      height: 1px;
      bottom: 0;
      content: '';
      display: block;
      position: absolute;
      background-color: $border-color;
    }

    .switch-1 {
      float: left;
      box-sizing: border-box;
      border-left: 1px solid $border-color;
    }

    .switch-1:last-child {
      box-sizing: border-box;
      border-right: 1px solid $border-color;
    }

    .w-4 {
      width: 25%;
    }

    .w-5 {
      width: 20%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-list/g_switch-6.vue